import { render, staticRenderFns } from "./PlasticForm.vue?vue&type=template&id=45a461e6"
import script from "./PlasticForm.vue?vue&type=script&lang=js"
export * from "./PlasticForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports